import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getProfilesRequest: null,
  getProfilesSuccess: ['profiles'],
  getProfilesFailure: ['error'],
  getProfileRequest: ['id'],
  getProfileSuccess: ['profile'],
  getProfileFailure: ['error'],
  addProfileRequest: ['profile', 'closeModal'],
  addProfileSuccess: ['profile'],
  addProfileFailure: ['error'],
  updateProfileRequest: ['id', 'profile', 'closeModal'],
  updateProfileSuccess: ['profile'],
  updateProfileFailure: ['error'],
  removeProfileRequest: ['id'],
  removeProfileSuccess: null,
  removeProfileFailure: ['error'],
  getMyPermissionsRequest: null,
  getMyPermissionsSuccess: ['permissions'],
  getMyPermissionsFailure: ['error'],
});

export const ProfilesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  profiles: [],
  currentProfile: null,
  permissions: {
    modules: [],
    companies: [],
    registrations: [],
  },
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getProfilesRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getProfilesSuccess = (state, { profiles }) =>
  state.merge({
    profiles,
    isLoading: false,
  });

const getProfilesFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const getProfileRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getProfileSuccess = (state, { profile }) =>
  state.merge({
    currentProfile: profile,
    isLoading: false,
  });

const getProfileFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addProfileRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addProfileSuccess = (state, { profile }) =>
  state.merge({
    profiles: [...state.profiles, profile],
    isLoading: false,
    openModal: false,
  });

const addProfileFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateProfileRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateProfileSuccess = (state, { profile }) =>
  state.merge({
    profiles: state.profiles.map((item) => {
      if (item.id === profile.id) {
        return profile;
      }
      return item;
    }),
    currentProfile: state.currentProfile?.id === profile.id ? profile : state.currentProfile,
    isLoading: false,
    openModal: false,
  });

const updateProfileFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeProfileRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeProfileSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const removeProfileFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const getMyPermissionsRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getMyPermissionsSuccess = (state, { permissions }) =>
  state.merge({
    permissions,
    isLoading: false,
  });

const getMyPermissionsFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PROFILES_REQUEST]: getProfilesRequest,
  [Types.GET_PROFILES_SUCCESS]: getProfilesSuccess,
  [Types.GET_PROFILES_FAILURE]: getProfilesFailure,
  [Types.GET_PROFILE_REQUEST]: getProfileRequest,
  [Types.GET_PROFILE_SUCCESS]: getProfileSuccess,
  [Types.GET_PROFILE_FAILURE]: getProfileFailure,
  [Types.ADD_PROFILE_REQUEST]: addProfileRequest,
  [Types.ADD_PROFILE_SUCCESS]: addProfileSuccess,
  [Types.ADD_PROFILE_FAILURE]: addProfileFailure,
  [Types.UPDATE_PROFILE_REQUEST]: updateProfileRequest,
  [Types.UPDATE_PROFILE_SUCCESS]: updateProfileSuccess,
  [Types.UPDATE_PROFILE_FAILURE]: updateProfileFailure,
  [Types.REMOVE_PROFILE_REQUEST]: removeProfileRequest,
  [Types.REMOVE_PROFILE_SUCCESS]: removeProfileSuccess,
  [Types.REMOVE_PROFILE_FAILURE]: removeProfileFailure,
  [Types.GET_MY_PERMISSIONS_REQUEST]: getMyPermissionsRequest,
  [Types.GET_MY_PERMISSIONS_SUCCESS]: getMyPermissionsSuccess,
  [Types.GET_MY_PERMISSIONS_FAILURE]: getMyPermissionsFailure,
});

